import { openDB } from 'idb';

export const useTimelineDb = async (dbName) => {

    const db = await openDB(dbName, 1, {
        upgrade(db) {
            db.createObjectStore('timeline', { keyPath: 'id' }).createIndex('updatedAt', 'updatedAt');
            db.createObjectStore('meta'); // key-value store
        }
    });

    const getLastUpdated = async () => {
        return await db.get('meta', 'lastUpdated');
    };

    const setLastUpdated = async (date) => {
        return await db.put('meta', date, 'lastUpdated');
    };

    const upsertItems = async (items) => {
        const tx = db.transaction(['timeline', 'meta'], 'readwrite');
        const timelineStore = tx.objectStore('timeline');
        const metaStore = tx.objectStore('meta');

        let maxUpdatedAt = null;

        for (const item of items) {
            if (item.deletedAt) {
                await timelineStore.delete(item.id);
            } else {
                await timelineStore.put(item);
            }

            if (!maxUpdatedAt || new Date(item.updatedAt) > new Date(maxUpdatedAt)) {
                maxUpdatedAt = item.updatedAt;
            }
        }

        // Only update lastUpdated if we actually processed any items
        if (maxUpdatedAt) {
            await metaStore.put(maxUpdatedAt, 'lastUpdated');
        }

        await tx.done;
    };
    const clearAll = async () => {
        const tx = db.transaction(['timeline', 'meta'], 'readwrite');
        await tx.objectStore('timeline').clear();
        await tx.objectStore('meta').clear();
        await tx.done;
    };

    const getAll = async () => {
        return await db.getAll('timeline');
    };

    return {
        getLastUpdated,
        upsertItems,
        getAll,
        clearAll
    };
};
